
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import request from "@/lib/request/request";
import Auth from "@/lib/common/auth";
import Job from "@/lib/job/job";
import { ExamV2Custom } from "@/lib/model/exambuilder/exam-v2";
import { ExamGetForm } from "@/lib/form/exam/ExamListForm";
import {
  QuestionV2,
  QuestionV2Object
} from "@/lib/model/exambuilder/question-v2";
import ExamList from "@/lib/model/exam/exam";
import {
  StructApplicationRuleV4,
  StructRuleNodeDetailV4,
  StructRuleNodeV4,
  applicationTypeList,
  appRules,
  tagRules,
  useIntList,
  useStringList,
  useRangeList
} from "./constant";
import { EOF_TOKEN } from "html2canvas/dist/types/css/syntax/tokenizer";

@Component({})
export default class ApplicationRule extends Vue {
  @Prop({}) exam!: ExamV2Custom;
  @Prop({}) examId!: number;
  @Prop({}) applicationRule!: any;
  @Prop({}) visible!: boolean;
  title = "规则集";

  selectExams: number | "" = "";
  loading = false;
  examList: ExamList[] = [];
  storeMap = new Map();
  preExam = 0;
  myExam = new ExamV2Custom();
  attributeList: any = [];
  dataTypeList: any = [];
  filterTagArray: string[] = [];
  appRules = appRules;
  tagRules = tagRules;
  useIntList = useIntList;
  useStringList = useStringList;
  useRangeList = useRangeList;
  applicationTypeList = applicationTypeList;
  relationEmptyList = ["为空", "不为空"]; // 不展示标签值的关系

  examForm: any = {};
  examGetForm = new ExamGetForm();

  applicationRuleList: StructApplicationRuleV4[] = [
    new StructApplicationRuleV4()
  ];
  applicationKey = 0;
  ruleKey = 0;

  @Watch("visible", { immediate: true })
  async getInfo(nval: any) {
    if (nval) {
      this.applicationRuleList[0].matchRuleRoot.subList = [
        new StructRuleNodeV4()
      ]; // 默认值为null，新建需要手动加一个
      this.storeMap.set(
        0,
        JSON.parse(JSON.stringify(this.applicationRuleList))
      );
      this.selectExams = this.examId || "";
      await this.getEngineList();
      await this.getExamList();
      if (this.exam) {
        this.selectExams = this.exam.examId || -1;
        this.myExam = JSON.parse(JSON.stringify(this.exam));
        this.filterTag();
        this.applicationRuleList =
          JSON.parse(
            JSON.stringify(
              this.exam.applicationRuleList.filter(
                (el: StructApplicationRuleV4) => el.type !== "级联面试分配"
              )
            )
          ) || [];
        console.log(this.applicationRuleList);
        this.anaylisList();
      } else {
        this.examId && (await this.getExamInfo(this.examId));
        if (this.applicationRule) {
          this.anaylisList();
          this.storeMap.set(this.examId, this.applicationRuleList);
        }
      }
    }
  }

  // 解析列表
  anaylisList() {
    let applicationRuleList: any = null;
    if (this.exam) {
      applicationRuleList =
        this.applicationRuleList.filter(el => el.type !== "级联面试分配") || [];
    } else {
      applicationRuleList = this.applicationRule
        ? [JSON.parse(JSON.stringify(this.applicationRule))]
        : [];
    }

    const ruleConstKey = [
      "ruleKey",
      "attribute",
      "relationship",
      "valueRange",
      "value1",
      "value2",
      "value",
      "valueInt",
      "valueStrings",
      "ruleId",
      "mergeType",
      "detail",
      "subList",
      "props"
    ];
    applicationRuleList.forEach((application: StructApplicationRuleV4) => {
      if (application.type !== "级联面试分配") {
        this.applicationKey--;
        application.applicationKey = this.applicationKey;
        const typeItem = this.getTypeItemWithType(application.type);
        application.tagStatusList = typeItem?.statusList as any;
        application.matchRuleRoot.subList.forEach(rule => {
          this.ruleKey++;
          rule.ruleKey = this.ruleKey;
          const propName: string[] = [];
          for (const key in rule.detail) {
            if (!ruleConstKey.includes(key) && rule.detail[key]) {
              if (key === "questionId") {
                propName.unshift(key);
              } else {
                propName.push(key);
              }
            }
          }
          if (propName.length > 0) {
            rule.detail.props = propName;
            this.attributeList.forEach((item: any) => {
              if (item.name === rule.detail.attribute) {
                if (propName.length === 1) {
                  const propAttrList = this.catchPropAttrList(0, item);
                  rule.detail.propAttrList = [propAttrList];
                  this.changeProp(propName[0], rule.detail);
                } else {
                  const arr: any = [];
                  propName.forEach((_: any, index: number) => {
                    const propAttrList = this.catchPropAttrList(index, item);
                    arr.push(propAttrList);
                    this.changeProp(_, rule.detail, arr);
                  });
                  rule.detail.propAttrList = arr;
                }
              }
            });
          } else {
            rule.detail.propAttrList = [[]];
          }
          if (rule.detail.valueRange && rule.detail.valueRange.length > 1) {
            rule.detail.value1 = rule.detail.valueRange[0] + "";
            rule.detail.value2 = rule.detail.valueRange[1] + "";
          } else if (this.useIntList.includes(rule.detail.attribute)) {
            rule.detail.value = rule.detail.valueInt;
          } else {
            rule.detail.value = rule.detail.valueOption
              ? (rule.detail.valueStrings as string[])
              : rule.detail.valueStrings?.join("，");
          }
          const dataType = this.attributeList.find(
            (el: any) => el.name === rule.detail.attribute
          )?.dataType;
          rule.detail.dataTypeList = this.dataTypeList
            .find((el: any) => el.name === dataType)
            ?.relationshipList.map((el: any) => ({ name: el }));
        });
      }
    });
    if (applicationRuleList.length > 0) {
      this.applicationRuleList = applicationRuleList;
    } else {
      this.addApplicationRule();
    }
  }

  getTypeItemWithType(type: string) {
    return this.applicationTypeList.find(el => el.value === type);
  }

  async getEngineList() {
    const res = await request.post("/aiExam/common/tagEngine");
    const data = res.data.data;
    this.attributeList = data.attributeList.filter(
      (el: any) => !this.filterTagArray.includes(el.name)
    );
    this.dataTypeList = data.dataTypeList;
  }

  async getExamInfo(examId: number) {
    if (examId) {
      if (this.storeMap.get(examId)) {
        this.applicationRuleList = this.storeMap.get(examId);
      } else {
        this.applicationRuleList = [new StructApplicationRuleV4()];
        this.applicationRuleList[0].matchRuleRoot.subList = [
          new StructRuleNodeV4()
        ]; // 默认值
      }
      this.preExam = examId;
      if (this.preExam !== 0) {
        this.storeMap.set(this.preExam, this.applicationRuleList);
      }
      this.examGetForm.examId = Number(examId);
      this.examGetForm.companyId = Number(Auth.companyId);
      const res = await ExamList.examGetAi(this.examGetForm);
      this.myExam = new ExamV2Custom().assign(res);
      this.myExam.setDefaultValue();
      const t = await this.getQuestionList();
      this.myExam.questionSelectedList = t.list;
      this.filterTag();
    } else {
      this.remoteMethod("");
    }
  }

  filterTag() {
    this.filterTagArray = [];
    if (this.myExam.fingerTest === 2) {
      this.filterTagArray.push("形体识别检测");
    }
    if (this.myExam.colorTest === 2) {
      this.filterTagArray.push("颜色识别检测");
    }
    if (
      this.myExam.bgCheckProductId === 0 ||
      this.myExam.bgCheckProductId === 2
    ) {
      this.filterTagArray.push("金融风险记录查询");
    }
    if (
      this.myExam.bgCheckProductId === 0 ||
      this.myExam.bgCheckProductId === 3
    ) {
      this.filterTagArray.push("负面社会安全记录查询");
    }
    if (this.myExam.replacePersonCheck === 2) {
      this.filterTagArray.push("换人检测");
    }
    if (this.myExam.livenessRecognition === 2) {
      this.filterTagArray.push("人脸核验");
    }
    if (this.myExam.dimensionGroupConfigList?.length > 0) {
      this.applicationTypeList.forEach(el => {
        if (el.value === "维度组评价" || el.value === "维度评价") {
          el.disabled = false;
        }
      });
    } else {
      this.filterTagArray.push("维度组成绩百分比");
      this.filterTagArray.push("维度组成绩百分比区间");
      this.applicationTypeList.forEach(el => {
        if (el.value === "维度组评价" || el.value === "维度评价") {
          el.disabled = true;
        }
      });
    }
    if (this.myExam.psycGaugeConfig.psycGaugeId !== 5) {
      this.filterTagArray.push("DVF1.0心理健康测量");
    }
    if (
      !this.myExam.questionSelectedList.some((el: any) => el.questionType === 5)
    ) {
      this.filterTagArray.push("填空题答案");
    }
    if (
      !this.myExam.questionSelectedList.some((el: any) => el.questionType === 7)
    ) {
      this.filterTagArray.push("选择题选项");
    }
    this.getEngineList();
  }

  async remoteMethod(query: string) {
    this.loading = true;
    await this.getExamList(query, true);
    this.loading = false;
  }

  async getExamList(query?: string, flag?: boolean) {
    this.examForm = {};
    this.examForm.companyId = parseInt(Auth.companyId);
    this.examForm.page = 1;
    this.examForm.pageSize = 10000;
    this.examForm.nameOrRemark = query || "";
    this.examForm.examId = this.examId || 0;
    this.examForm.asCompany = 0;
    if (this.examId && !flag) {
      this.examForm.examIdList = [this.examId];
    }
    const res = await Job.getAllExam(this.examForm);
    // const res = await ExamList.getList(this.examForm)
    this.examList = res.list;
  }

  addTag(subList: StructRuleNodeV4[]) {
    this.ruleKey++;
    const ruleNode = new StructRuleNodeV4();
    ruleNode.ruleKey = this.ruleKey;
    subList.push(ruleNode);
  }

  removeTag(
    ruleKey: number | undefined,
    subList: StructRuleNodeV4[],
    application: StructApplicationRuleV4
  ) {
    application.matchRuleRoot.subList = subList.filter(
      el => el.ruleKey !== ruleKey
    );
  }

  addApplicationRule() {
    this.applicationKey--;
    const applicationRule = new StructApplicationRuleV4();
    applicationRule.applicationKey = this.applicationKey;
    applicationRule.matchRuleRoot.subList = [new StructRuleNodeV4()]; // 默认值
    this.applicationRuleList.push(applicationRule);
  }

  deleteApplicationRule(key?: number) {
    this.applicationRuleList = this.applicationRuleList.filter(
      el => el.applicationKey !== key
    );
  }

  changeAttr(attr: string, detail: StructRuleNodeDetailV4) {
    this.attributeList.forEach((item: any) => {
      if (item.name === attr) {
        this.$set(detail, "value", "");
        this.$set(detail, "value1", "");
        this.$set(detail, "value2", "");
        this.$set(detail, "relationship", "");
        const dataTypeList = this.dataTypeList
          .filter((el: any) => el.name === item.dataType)[0]
          .relationshipList.map((el: any) => ({ name: el }));
        this.$set(detail, "dataTypeList", dataTypeList);
        this.$set(detail, "props", item.extraNeedList);
        item.extraNeedList.forEach((el: any) => {
          this.$set(detail, el, "");
        });
        // extraNeedList为空属性与类型相同
        if (!item.extraNeedList.length) {
          this.$set(detail, "propAttrList", [[]]);
        } else if (item.extraNeedList.length === 1) {
          // 1个关联项，对应面试中格式为普通数组的 eg.['1','2']
          const propAttrList = this.catchPropAttrList(0, item);
          this.$set(detail, "propAttrList", [propAttrList]);
        } else {
          // 大于1个关联项
          const arr: any = [];
          item.extraNeedList.forEach((_: any, index: number) => {
            const propAttrList = this.catchPropAttrList(index, item);
            arr.push(propAttrList);
          });
          this.$set(detail, "propAttrList", arr);
        }
      }
    });
  }

  changeProp(item: string, detail: StructRuleNodeDetailV4, temp?: any) {
    this.$set(detail, "valueOption", "");
    if (item === "paramName") {
      const paramItem = this.myExam.paramList.filter(
        el => el.name === detail.paramName
      )[0];
      if (paramItem.inputType === "choice") {
        this.$set(
          detail,
          "valueOption",
          paramItem.singleChoiceOptions.map(el => ({ name: el }))
        );
      } else if (paramItem.inputType === "multiChoice") {
        this.$set(
          detail,
          "valueOption",
          paramItem.mutiChoiceOptions.map(el => ({ name: el.key }))
        );
      }
      return paramItem?.inputType;
    } else if (
      detail.props &&
      detail.props.length > 1 &&
      item === "questionId"
    ) {
      // 填空题
      const question = this.myExam.questionSelectedList.filter(
        el => el.questionId === detail.questionId
      )[0];
      const blankNum = question?.blankQuestionConfig.answerList.length;
      const options = Array.from({ length: blankNum }).map((_, index) => ({
        name: `第${index + 1}空`,
        value: index + 1
      }));
      if (temp) {
        temp.push(options);
      } else {
        if (detail.propAttrList) {
          this.$set(
            detail.propAttrList,
            1,
            Array.from({ length: blankNum }).map((_, index) => ({
              name: `第${index + 1}空`,
              value: index + 1
            }))
          );
        }
      }
    }
  }

  getStatusList(value: string, application: StructApplicationRuleV4) {
    // application.auditStatus = "";
    this.applicationTypeList.forEach(item => {
      if (item.value == value) {
        application.tagStatusList = item.statusList;
      }
    });
  }

  catchPropAttrList(index: number, item: any) {
    // 通用处理，对应面试中格式为普通数组的 eg.['1','2']
    const normalMap = {
      // questionId: "questionIdList",
      dimensionName: "dimensionKeyList"
    };
    if (normalMap[item.extraNeedList[index]]) {
      const propAttrList = this.myExam[
        normalMap[item.extraNeedList[index]]
      ].map((el: any) => ({ name: el, value: el }));
      return propAttrList;
    } else if (item.extraNeedList[index] === "paramName") {
      // paramName: 'paramList'
      const propAttrList = this.myExam.paramList
        .filter(el => el.isShow === 1)
        .map((el: any) => ({ name: el.name, value: el.name }));
      return propAttrList;
    } else if (item.extraNeedList[index] === "cvArgName") {
      return [{ name: "当前职位" }];
    } else if (item.extraNeedList[index] === "questionId") {
      return this.myExam.questionSelectedList.map((el: any) => ({
        name: "【" + el.getQuestionTypeText() + "】" + el.descTextOnly,
        value: el.questionId
      }));
    } else if (item.extraNeedList[index] === "dimensionGroupName") {
      return (
        this.myExam.dimensionGroupConfigList.map((el: any) => ({
          name: el.groupName,
          value: el.groupName
        })) || []
      );
    } else {
      return [];
    }
  }

  async ok() {
    const { code, message } = await this.checkData();
    if (code === 200) {
      const applicationRuleList = this.joinData();
      if (this.exam) {
        this.$emit("ok", applicationRuleList, "tag");
      } else {
        for (let i = 0; i < applicationRuleList.length; i++) {
          const application = applicationRuleList[i];
          await this.saveApplication(application);
        }
        this.$emit("ok");
      }
      this.close();
    } else {
      this.$message.error(message);
    }
  }

  async saveApplication(applicationRule: StructApplicationRuleV4) {
    await request.post("/aiExam/applicationRule/save", {
      companyId: Auth.companyId,
      examId: this.selectExams,
      ...applicationRule
    });
  }

  async checkData(): Promise<{ code: number; message: string }> {
    return new Promise(reslove => {
      if (!this.selectExams) {
        return reslove({
          code: 40080,
          message: "请选择面试"
        });
      }
      const errorArray = [];
      this.applicationRuleList.forEach((application, index) => {
        const form = this.$refs["application" + index][0];
        form.validate((valid: boolean) => {
          if (!valid) errorArray.push(valid);
        });
        application.matchRuleRoot.subList.forEach((rule, ruleIndex) => {
          const ruleForm = this.$refs["rule" + index + ruleIndex][0];
          ruleForm.validate((valid: boolean) => {
            if (!valid) errorArray.push(valid);
          });
        });
      });
      if (errorArray.length > 0) {
        return reslove({
          code: 40080,
          message: "缺少必填项"
        });
      }
      return reslove({ code: 200, message: "成功" });
    });
  }

  joinData(): StructApplicationRuleV4[] {
    const applicationRuleList = JSON.parse(
      JSON.stringify(this.applicationRuleList)
    );
    applicationRuleList.forEach((application: StructApplicationRuleV4) => {
      application.matchRuleRoot.subList.forEach(rule => {
        if (this.useIntList.includes(rule.detail.attribute)) {
          rule.detail.valueInt = isNaN(Number(rule.detail.value))
            ? 0
            : Number(rule.detail.value);
        } else if (
          this.useStringList.includes(rule.detail.attribute) &&
          rule.detail.value
        ) {
          rule.detail.valueStrings = Array.isArray(rule.detail.value)
            ? (rule.detail.value as string[])
            : String(rule.detail.value).split("，");
        } else {
          rule.detail.valueRange = [
            Number(rule.detail.value1),
            Number(rule.detail.value2)
          ];
        }
      });
    });
    return applicationRuleList;
  }

  //更新已选题目list
  async getQuestionList() {
    const param = {
      questionIdList: this.myExam?.questionIdList,
      dimensionKeyFilterList: this.myExam?.dimensionKeyList
    };
    return await QuestionV2Object.get(param);
  }

  close() {
    this.$emit("update:visible", false);
  }
}
